// A board's columns, each with its statuses as chips: where on the board a
// person goes. Moving a card (the person's role list) and placing a new one
// (Add to board) both pick here.
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { BoardColumnType, Status } from "../../api/assignments/board-types";

interface BoardStatusGridProps {
	columns: BoardColumnType[];
	/** The status the person has now, drawn outlined; null for a new card. */
	currentStatus: string | null;
	onPick: (column: BoardColumnType, status: Status) => void;
}

export const BoardStatusGrid = ({
	columns,
	currentStatus,
	onPick,
}: BoardStatusGridProps) => (
	<Stack data-component="board-status-grid">
		{columns.map((column) => (
			<Stack key={column.name} data-component="board-status-grid-column">
				<Typography
					sx={{ fontWeight: "bold", p: 1 }}
					data-component="board-status-grid-column-name"
				>
					{column.name}
				</Typography>
				<Grid
					container
					spacing={1}
					sx={{ p: 1, maxWidth: 400 }}
					data-component="board-status-grid-statuses"
				>
					{column.statuses.map((status) => (
						<Grid key={status.name} data-component="board-status-grid-cell">
							<Chip
								variant={
									status.name === currentStatus
										? "outlined"
										: "filled"
								}
								label={status.name}
								onClick={() => onPick(column, status)}
								data-component="board-status-grid-status"
							/>
						</Grid>
					))}
				</Grid>
			</Stack>
		))}
	</Stack>
);
